import { render, staticRenderFns } from "./goods-vip-forever.vue?vue&type=template&id=7586afdb&scoped=true"
import script from "./goods-vip-forever.vue?vue&type=script&lang=js"
export * from "./goods-vip-forever.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-forever.vue?vue&type=style&index=0&id=7586afdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7586afdb",
  null
  
)

export default component.exports